type DashboardT = (key: string, options?: { defaultValue?: string }) => string

export const ANALYTICS_CARD_SLUG: Record<string, string> = {
  'Span of Control': 'spanOfControl',
  'Performance Distribution': 'performanceDistribution',
  'Compensation Bands': 'compensationBands',
  'Tenure Distribution': 'tenureDistribution',
  'Flight Risk': 'flightRisk',
  'Succession Readiness': 'successionReadiness',
  'Vacancy Highlight': 'vacancyHighlight',
}

export const DEPT_VIEW_NAME_SLUG: Record<string, string> = {
  'Customer Success': 'customerSuccess',
  'Design': 'design',
  'Engineering': 'engineering',
  'Executive': 'executive',
  'Finance': 'finance',
  'Legal': 'legal',
  'Marketing': 'marketing',
  'Operations': 'operations',
  'People': 'people',
  'Human Resources': 'people',
  HR: 'people',
  'Product': 'product',
  'Sales': 'sales',
}

export const resolveAnalyticsSlug = (raw: string): string | undefined => {
  const n = raw.trim()
  if (ANALYTICS_CARD_SLUG[n]) return ANALYTICS_CARD_SLUG[n]
  const lower = n.toLowerCase()
  for (const [k, slug] of Object.entries(ANALYTICS_CARD_SLUG)) {
    if (k.toLowerCase() === lower) return slug
  }
  return undefined
}

export const resolveDeptViewSlug = (raw: string): string | undefined => {
  const n = raw.trim()
  if (DEPT_VIEW_NAME_SLUG[n]) return DEPT_VIEW_NAME_SLUG[n]
  const lower = n.toLowerCase()
  for (const [k, slug] of Object.entries(DEPT_VIEW_NAME_SLUG)) {
    if (k.toLowerCase() === lower) return slug
  }
  return undefined
}

export const tryTranslateOrgChartSystemDiagramName = (
  rawName: string,
  tDashboard: DashboardT,
): string | undefined => {
  const raw = (rawName ?? '').trim()
  if (!raw) return undefined
  const analyticsSlug = resolveAnalyticsSlug(raw)
  if (analyticsSlug) {
    return tDashboard(`domainFolder.analyticsCards.${analyticsSlug}.title`, { defaultValue: raw }) as string
  }
  const deptSlug = resolveDeptViewSlug(raw)
  if (deptSlug) {
    return tDashboard(`domainFolder.deptViewNames.${deptSlug}`, { defaultValue: raw }) as string
  }
  return undefined
}
